var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-col',{attrs:{"span":_vm.span,"flex":_vm.flex}},[_c('div',{staticClass:"title_col"},[_c('div',[_c('div',[_c('span',[_vm._v(_vm._s(_vm.title))])]),_c('div',[_c('span',[_vm._v(_vm._s(_vm.value))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }